import { Clock } from "lucide-react";
import Button from "../../../components/Button/Button";
import { formatTimeRange, getSubjectTone } from "../utils/lessonPlanUtils";

/** A timetable period that has no lesson plan yet. */
const EmptySlotCard = ({ lesson, onCreate }) => {
  const tone = getSubjectTone(lesson.subjectName);
  const time = formatTimeRange(lesson.startTime, lesson.endTime);

  return (
    <article className={`card lp-lesson-card lp-lesson-card--empty lp-accent-${tone}`}>
      <div className="lp-lesson-card__body">
        <div className="lp-lesson-card__meta">
          <strong>{lesson.subjectName}</strong>
          <span className={`lp-dot lp-bg-${tone}`} />
          <span>{lesson.programName}</span>
        </div>
        <div className="lp-lesson-card__tags">
          {time && (
            <span className="lp-chip lp-chip--muted">
              <Clock size={12} /> {time}
            </span>
          )}
          <span className="lp-chip lp-chip--muted">No Lesson Plan</span>
        </div>
      </div>
      <div className="lp-lesson-card__actions">
        <Button variant="outline-primary" size="sm" onClick={() => onCreate(lesson)}>
          Create Lesson Plan
        </Button>
      </div>
    </article>
  );
};

export default EmptySlotCard;
